import PropTypes from "prop-types";

const ShareButton = ({ bgColor = "#fff", onClick = () => {}, children }) => {
  return (
    <button
      className="w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ease-in-out transform hover:scale-110"
      style={{
        backgroundColor: bgColor,
        boxShadow:
          "0 8px 16px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(255, 255, 255, 0.2)",
        transition: "box-shadow 0.3s ease-in-out, transform 0.3s ease-in-out",
      }}
      onClick={(e) => {
        e.stopPropagation();
        if (onClick) onClick();
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.boxShadow =
          "0 12px 24px rgba(0, 0, 0, 0.7), inset 0 0 15px rgba(255, 255, 255, 0.4)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.boxShadow =
          "0 8px 16px rgba(0, 0, 0, 0.5), inset 0 0 10px rgba(255, 255, 255, 0.2)";
      }}
    >
      {children}
    </button>
  );
};

ShareButton.propTypes = {
  bgColor: PropTypes.string,
  onClick: PropTypes.func,
  children: PropTypes.node,
};

export default ShareButton;
